import React from "react";
import NavMain from "../Components/NavMain";
import Calculator from "../Components/Calculator";

const Main = () => {
  return (
    <>
      <NavMain />
      <Calculator />
    </>
  );
};

export default Main;
